import { useMutation, useQuery } from '@tanstack/react-query'
import { ApiError } from '../../api/client'
import { adamCleanQuery, cleanRemovedActions } from '../../api/settingsEaseedeskAdamIntop'
import { toast } from '../../ui/notify'
import { LoadFailed } from '../../ui/LoadFailed'
import { Spinner } from '../../ui/Spinner'
import { Forbidden } from './AdamIntopSettingsPage'

/**
 * Settings → Easeedesk → Adam Intop → Clean Removed Actions.
 *
 * Perechea lui `version-3/easeedesk_settings/adam_intop/clean_removed_actions.php`
 * si a lui `clean_removed_actions-1.js`: o pagina cu un buton, care sterge
 * de-a binelea actiunile marcate ca scoase.
 *
 * Butonul curata acum NUMAI actiunile furnizorului. Pe calea veche stergerea
 * n-avea nicio conditie de furnizor, deci un administrator lua actiunile
 * scoase ale tuturor - vezi `DbalAdamIntopSettingsSource`.
 *
 * Dreptul e al ecranului, ca in portal:
 * `settings.adam_intop_clean_removed_actions.read`.
 */
export function AdamIntopCleanActionsPage() {
  const shell = useQuery(adamCleanQuery())

  const clean = useMutation({
    mutationFn: () => cleanRemovedActions(),
    onSuccess: (result) => toast(result.message ?? 'Done.', 'Success'),
    onError: (error) => toast(error instanceof ApiError ? error.message : 'Something went wrong.', 'Error', 'error'),
  })

  if (shell.error instanceof ApiError && shell.error.status === 403) return <Forbidden />
  if (shell.error) {
    return <LoadFailed error={shell.error} onRetry={() => void shell.refetch()} what="this screen" />
  }
  if (!shell.data) return <Spinner />

  return (
    <div>
      <h4>
        <strong>Clean Removed Actions</strong>
      </h4>
      <label className="color" style={{ marginBottom: 0 }}>
        Clean <strong>Removed Actions</strong> for Adam Intop
      </label>
      <button
        type="button"
        className="btn btn-danger pull-right me-2"
        id="clean-removed-actions"
        disabled={clean.isPending}
        onClick={() => {
          /* Intrebarea din swal, cu acelasi inteles: ce pleaca de aici nu se
             mai intoarce. */
          if (!window.confirm('Are you sure?\nThe removed actions will be permanently deleted.')) return
          clean.mutate()
        }}
      >
        <i className="fas fa-trash" aria-hidden="true"></i> Permanently Delete Removed Actions
      </button>
      <hr />
    </div>
  )
}
